(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (e) => {
    const link = e.target.closest('[data-logout-clear-cart]');
    if (!link) return;

    e.preventDefault();

    try {
      await fetch('/cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
      });
    } catch (err) {
      console.warn('Cart clear failed, continuing logout');
    }

    window.location.href = link.getAttribute('href');
  });
  } catch(e) { console.error(e); }
})();

})();
